/* Logo und Home: immer zur echten Startseite. Keine Hash-Hüllen mehr – die haben Inhalte verdoppelt. */
(function () {
  'use strict';

  function homeUrl() {
    if (window.Shopify && Shopify.routes && Shopify.routes.root) return Shopify.routes.root;
    return '/';
  }

  function goHome(e) {
    if (e) e.preventDefault();
    window.location.assign(homeUrl());
  }

  window.FFGoHome = goHome;

  document.querySelectorAll('[data-ff-home]').forEach(function (el) {
    el.setAttribute('href', homeUrl());
    el.addEventListener('click', goHome);
  });
})();
